import i18n from './i18n';

/* A status that is DATA, drawn in the reader's language (2026-10-21) — the words in src/locales/xVal.js. Stored,
   compared, filtered and exported in English as before; only what a pill or a cell PRINTS goes through here.
   A stage value is often a word plus a round ("In Progress P2", "RM Waiting P1", "Sewing Counter"): the word is
   translated and the round kept. Anything this table does not know is printed as it is — it is still a fact. */
const KEY = {
  'on track': 'onTrack', concern: 'concern', delayed: 'delayed', 'on hold': 'onHold', complete: 'complete',
  completed: 'completed', dropped: 'dropped', 'ship finished': 'shipFinished', priority: 'priority',
  advance: 'advance', rework: 'rework', confirmed: 'confirmed', 'internal trial': 'internalTrial',
  'pending outcome': 'pendingOutcome', 'in production': 'inProduction', 'rm waiting': 'rmWaiting',
  'in progress': 'inProgress', pending: 'pending', 'waiting feedback': 'waitingFeedback',
  'waiting manager approval': 'waitingManagerApproval', 'waiting ceo approval': 'waitingCeoApproval',
  'draft po issued': 'draftPoIssued', sewing: 'sewing', no: 'no', high: 'high', medium: 'medium', low: 'low',
};
const ROUNDED = /^(In Progress|RM Waiting|Sewing)\s+(P\d+|Counter)$/i;

export const valueLabel = (value) => {
  if (value == null) return value;
  const raw = String(value);
  const v = raw.trim();
  const key = KEY[v.toLowerCase()];
  if (key) return i18n.t(`xVal.${key}`);
  const m = v.match(ROUNDED);
  if (m) return `${i18n.t(`xVal.${KEY[m[1].toLowerCase()]}`)} ${m[2]}`;
  return raw;
};

export default valueLabel;
